import { useState } from "react";
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { Layout } from "../../GlobalComponent/Layout/Layout";
import RateCardMapping from "../RateCardMapping/RateCardMapping";
import PocoAmbulanceRateCard from "../PocoAmbulanceRateCard/PocoAmbulanceRateCard";

export const PocoRateCards = () => {
    const [clearFormFour, setClearFormFour] = useState(false);
    const [clearFormFive, setClearFormFive] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);

    const handleTabChange = (index: number) => {
        setSelectedTab(index);
        setClearFormFour(!clearFormFour);
        setClearFormFive(!clearFormFive);
    };

    return (
        <Layout>
            <Box w="100%">
                <Tabs index={selectedTab} onChange={handleTabChange} variant="soft-rounded" colorScheme="green">
                    <TabList>
                        <Tab>Rate Card Mapping</Tab>
                        <Tab>Poco Ambulance RateCard</Tab>
                    </TabList>
                    <TabPanels>
                        <TabPanel>
                            <RateCardMapping clearFormFour={clearFormFour} setClearFormFour={setClearFormFour} />
                        </TabPanel>
                        <TabPanel>
                            <PocoAmbulanceRateCard clearFormFive={clearFormFive} setClearFormFive={setClearFormFive} />
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </Box>
        </Layout>
    );
};
